export class PreviousVaccineModel {
    public id: string;
    public vaccineId: string;
    public vaccineName: string;
    public administeredDateTimestamp: number;
    public centre: string;
    public batchNo: string;
    public expireDateTimestamp?: number;
    public monthCoverLeft?: number;
    public isPatientVaccines: boolean;
    public isCourseInCompleted: boolean;
}

export class NewVaccineAddedModel {
    public diseaseId: string;
    public isCourseCompleted: boolean;
    public dateAdministered: string;
    public otherCentreId: string;
    public vaccineId: string;
    public isVerbalSource: boolean;
}

export class DiseaseWithVaccinesModel {
    public diseaseId: string;
    public diseaseName: string;
    public vaccines: Array<{
        vaccineId: string,
        vaccineName: string,
        monthExpectedCover: number
    }>;
}

export class VaccineCourseStatus {
    public static readonly complete = 'complete';
    public static readonly incomplete = 'incomplete';
}









// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/consultation-process/previous-vaccine.model.ts